import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state:{
		navigationList: []
	},
	mutations: {
		setNavigationList(state, list) {
			state.navigationList = list
		}
	},
	actions: {

	},
	modules: {
	}
})

export default store
